import { useEffect, useState } from "react";
import UpdateButtonTrigger from "../../../../../../shared/components/button/UpdateButtonTrigger";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import { useTranslation } from "react-i18next";
import UpdateClientPlatformMarginsForm from "./UpdateClientPlatformMarginsForm";

const UpdateClientPlatformMarginsDialog = ({
  onSubmitHandler,
  clients,
  platforms,
  clientPlatformMargin,
  externalOpen,
  hiddenClassName = "",
  platform,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  useEffect(() => {
    setIsOpen(externalOpen?.externalOpen);
  }, [externalOpen]);

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger className={hiddenClassName} />}
      title={t("clientPlatformMargins.updateForm.title")}
      description={t("clientPlatformMargins.updateForm.description")}
      content={
        <UpdateClientPlatformMarginsForm
          onSubmitHandler={onSubmit}
          clients={clients}
          platforms={platforms}
          clientPlatformMargin={clientPlatformMargin}
          platform={platform}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default UpdateClientPlatformMarginsDialog;
